<template lang="pug">
  .resource-view-wrapper(:class="'context-' + context")
    include RegisterPacks.pug
</template>

<script>
import _ from 'underscore'
import PrivateRouterLink from '@/directives/PrivateRouterLink'
import { mapState } from 'vuex';

export default {
  name: 'RegisterPacks',
  props: [],
  components: {
    PrivateRouterLink,
  },
  computed: mapState([
    "context",
  ]),
  data() {
    return {}
  },
  created() {},
}
</script>

<style lang="scss">
@import './../../variables';
@import './../../variables_colreps';

.resource-view-wrapper {
  @import 'RegisterPacks';
}

</style>



// WEBPACK FOOTER //
// src/components/register/RegisterPacks.vue